"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slider = _interopRequireDefault(require("./slider"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _slider.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-slick/lib/index.js
// module id = 1930
// module chunks = 0